var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3759 3.58402C11.6057 3.23943 12.0713 3.14629 12.4159 3.37601C12.7606 3.60576 12.8537 4.07141 12.6239 4.41605L7.62395 11.916C7.49937 12.1029 7.29761 12.2239 7.07414 12.2461C6.85054 12.2683 6.62853 12.1892 6.46965 12.0303L3.46965 9.03031C3.1768 8.73741 3.17677 8.26264 3.46965 7.96976C3.76253 7.67692 4.23731 7.67692 4.5302 7.96976L6.88371 10.3233L11.3759 3.58402Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e50d2a971a8671f1acd6e8d2be9e26d1.svg";
export { ForwardRef as ReactComponent };